export const strandLossColors = {
  background: "#111111",
  warning: "#FFD600",
  undeclared: "#E53935",
} as const;
